import React from "react";
import UploadInputDefault from "./UploadInputDefault";
import UploadInputDramaturgy from "./UploadInputDramaturgy";

const WrapperInput = (props) => {
  const { inputComponent, ...restProps } = props;
  const Wrapper = {
    Default: <UploadInputDefault {...restProps} />,
    Dramaturgy: <UploadInputDramaturgy {...restProps} />,
  };

  return Wrapper[inputComponent];
};

export default WrapperInput;
